module.exports = __webpack_public_path__ + "img/5.1f9fd3cc.jpg";